export function isAndroidWebView(userAgent) {
  var ua = userAgent !== null && userAgent !== void 0 ? userAgent : true ? window.navigator.userAgent : "";
  return /wv/gi.test(ua) || /CatchOfTheDayAndroidApp/gi.test(ua);
}
export function isAndroidHybridApp(userAgent) {
  var ua = userAgent !== null && userAgent !== void 0 ? userAgent : true ? window.navigator.userAgent : "";
  return /CatchOfTheDayAndroidApp/gi.test(ua);
}